import { useMemo, useState, useRef, useEffect, useCallback } from "react";

import {
  Box,
  HStack,
  Heading,
  CircularProgress,
  Container,
  Breadcrumb,
  BreadcrumbItem,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

// import { useHistory } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import PartialBCPL from "./PartialBCPL";

// import { ReactComponent as HistoryMeter } from "assets/svg/history-meter.svg";
// import { ReactComponent as PerformanceChart } from "assets/svg/inpl-chart.svg";
// import { ReactComponent as EmptyTransactionState } from "assets/svg/empty-inpl.svg";

import {
  useGetLoanRecordsQuery,
  useGetLoanBalanceQuery,
  // useGetLoanProfileQuery,
} from "services/walletApi";

import constants from "config/constant";

// import { useGetCoinToUsdRateQuery } from "services/rateApi";

// import isEmpty from "lodash/isEmpty";
// import toLower from "lodash/toLower";
// import { format, parseISO } from "date-fns";
// import formatter from "util/formatter";
// import toUpper from "lodash/toUpper";
// import take from "lodash/take";

export default function BCPL(props) {
  const currentPage = "Home";

  const { data, isLoading } = useGetLoanRecordsQuery();
  // const { data: loanProfile } = useGetLoanProfileQuery();

  console.log("HISTORY DATA", data);

  const coinName = useCallback((coin) => {
    const map = {
      [coin]: coin,
      tbtc: "btc",
      teth: "eth",
    };

    return map[coin];
  }, []);

  const { data: loanBalanceData } = useGetLoanBalanceQuery();

  // console.log("LOAN BALANCE", loanBalanceData);

  const isBalanceLoaded = useRef(false);

  // const loans = useMemo(() => data?.loans, [data]);

  // const runningLoan = useMemo(
  //   () => loans?.find((loan) => loan?.loanStatus === "running"),
  //   [loans]
  // );

  // console.log("RUNNING LOAN", runningLoan);

  const [state, setState] = useState();

  const handleState = (newState) => setState({ ...state, ...newState });

  // const { data: rates, isFetching } = useGetCoinToUsdRateQuery(
  //   state?.coin ?? "btc"
  // );

  const loanBalance = useMemo(() => {
    const values = loanBalanceData?.arraySums[0];
    return values;
  }, [loanBalanceData]);

  // const canRequestLoan = useMemo(() => {
  //   if (isEmpty(loans ?? [])) return false;
  //   return !!!loans?.find(
  //     (loan) => loan?.loanStatus === "running" || loan?.loanStatus === "pending"
  //   );
  // }, [loans]);

  useEffect(() => {
    if (loanBalance && !isBalanceLoaded.current) {
      handleState({ coin: coinName(loanBalance?.coin) });
      isBalanceLoaded.current = true;
    }

    // eslint-disable-next-line
  }, [loanBalance, isBalanceLoaded]);

  // console.log("CAN REQUEST LOAN", canRequestLoan);

  // console.log("LOANS", loans);
  // console.log("LOAN BALANCE", loanBalanceData, loanBalance);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="bcpl">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <HStack>
                <Heading fontSize="3xl">Buy Crypto, Pay later</Heading>
                {isLoading && (
                  <CircularProgress
                    ml="20px !important"
                    isIndeterminate
                    color="var(--primary)"
                    size="20px"
                  />
                )}
              </HStack>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/home">Home</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="/dashboard/bcpl">
                    BCPL
                  </BreadcrumbLink>
                </BreadcrumbItem>

                {/* <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Withdraw
                  </BreadcrumbLink>
                </BreadcrumbItem> */}
              </Breadcrumb>
            </Box>

            <PartialBCPL availableCoins={constants.supportedLoanableCoins} />
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
